/**
 * Check whether a given number is between the min and max defined
 * and return the specified min/max if the value is beyond those
 * boundaries; else, return the value
 * @param value: number
 * @param min: number
 * @param max: number
 * @return: number
 */
export default function modifyWithMinMax(value: number, min?: number, max?: number): number {
  if (value || value === 0) {
    if (min != null && value < min) {
      return min;
    }
    if (max != null && value > max) {
      return max;
    }
  }

  return value;
}
